import { Box, IconButton, Paper, Typography } from "@mui/material"
import { ChevronLeftOutlined } from "@mui-symbols-material/w300"
import { useParams, useRouter } from "@tanstack/react-router"
import { type FC } from "react"

import { UserDetailsHeader, UserRoles } from "../components"
import { useGetUser } from "../hooks"

const UserContainer: FC = () => {
  const { userId } = useParams({ from: "/app/admin/system-admin/users/$userId" })

  const { user, fetching } = useGetUser(userId)

  const router = useRouter()

  return (
    <Box className='flex h-full flex-col gap-4'>
      <Paper elevation={0} className='flex min-h-0 grow flex-col space-y-7 overflow-hidden bg-white'>
        <Box className='flex items-center gap-2'>
          <IconButton
            aria-label='back to contacts'
            className='rounded bg-gray-200 text-primary'
            onClick={() => router.history.back()}
          >
            <ChevronLeftOutlined />
          </IconButton>
          <Typography variant='h5' color='primary' fontWeight='normal'>
            User Information
          </Typography>
        </Box>

        <Box className='flex flex-col gap-6'>
          {fetching ? (
            <Box className='flex items-center justify-center'>
              <Typography variant='h5'>Loading...</Typography>
            </Box>
          ) : (
            <>
              <UserDetailsHeader user={user} />

              <UserRoles user={user} />
            </>
          )}
        </Box>
      </Paper>
    </Box>
  )
}

export default UserContainer
